export type ReactingPerson = {id: string; fullName: string};

export type CommentReaction = {
	emoji: string;
	count: number;
	viewerHasReacted: boolean;
	persons: ReadonlyArray<ReactingPerson>;
};

/**
 * What the reactions will look like once the server has applied the change — the optimistic
 * response. Mirrors the server: new emojis go last, emptied ones disappear, and adding or removing
 * something that is already so changes nothing.
 */
export const applyReactionChange = (
	reactions: ReadonlyArray<CommentReaction>,
	emoji: string,
	viewer: ReactingPerson,
	add: boolean
): CommentReaction[] => {
	const existing = reactions.find(reaction => reaction.emoji === emoji);

	if (add) {
		if (existing?.viewerHasReacted) return [...reactions];
		if (!existing) return [...reactions, {emoji, count: 1, viewerHasReacted: true, persons: [viewer]}];
		return reactions.map(reaction =>
			reaction === existing
				? {...reaction, count: reaction.count + 1, viewerHasReacted: true, persons: [...reaction.persons, viewer]}
				: reaction
		);
	}

	if (!existing?.viewerHasReacted) return [...reactions];
	if (existing.count <= 1) return reactions.filter(reaction => reaction !== existing);
	return reactions.map(reaction =>
		reaction === existing
			? {
					...reaction,
					count: reaction.count - 1,
					viewerHasReacted: false,
					persons: reaction.persons.filter(person => person.id !== viewer.id),
			  }
			: reaction
	);
};
